import { io } from "socket.io-client";
import { url } from "../baseUrl.js";
// для dev
// export const socket = io("http://localhost:3001", {
//   withCredentials: true,
// });

// для проекта с сокетами
// project
const backendURL = `${url}`;

export const socket = io(backendURL, {
  withCredentials: true,
  transports: ["websocket"], // <--- добавлено
});
